export default __webpack_public_path__ + "static/media/Kannada_ef_2.549d381c.mp3";